import {AMBROSIA_URL} from '../../helpers/auth-header'
import Axios from 'axios'

export default {
    
    /**
	 *
	 * @param commit
	 * @param dispatch
     * @param state
	 * @param event
	 */
    Agree({commit,dispatch,state},e){
        dispatch('ShowLoadingToast', {'text': 'Confirmando pedido' })
        Axios.post(`${AMBROSIA_URL}/order/${state.order.id}/confirm`)
        .then(response => {
            dispatch('SetOrder', response.data.data)
            dispatch('ShowToast', { 'icon':'success', 'title':'Se confirmo el pedido'})
            commit('StateAssign',{ checkoutStep: 'ShippingProfileStep' })
        })
        .catch(error => {
            dispatch('ShowToast', { 'icon':'error', 'title':'Error al confirmar pedido'})
        })
    },

     /**
	 *
	 * @param commit
	 * @param dispatch
	 * @param event
	 */
    TimeConfirm({commit,dispatch,state},e){
        dispatch('ShowLoadingToast', {'text': 'Agregando metodo de envio' })
        //{isExpress:false,regularTimespanFrom:0,regularTimespanTo:currentShippingProfile.programmedTimespan}
        if(e.target.deliveryType.value){
            let postData
       
            if(e.target.deliveryType.value == 'reg'){
                let regularTime = state.order.isSelfSufficient ? state.shippingProfile.regularTimespan : state.shippingProfile.programmedTimespan
                postData ={regularTimespanFrom: 0, regularTimespanTo:regularTime}
            }
            if(e.target.deliveryType.value == 'express'){
                postData = {express:true}
            }
            if(e.target.deliveryType.value =='programmed'){
                let data = e.target.timeToDelivery.value
                let arr = data.split('|')
                postData = {express:false,lowerBound:arr[0],upperBound:arr[1]}
            }
            Axios.post(`${AMBROSIA_URL}/order/${state.order.id}/add-shipping-profile`,postData)
            .then(r => {
                dispatch('SetOrder', r.data.data )
                commit('StateAssign',{ checkoutStep: 'PaymentStep' })
                dispatch('ShowToast', { 'icon':'success', 'title':'Se agrego el metodo de envio'})
            })
            .catch(error => {
                dispatch('ShowToast', { 'icon':'error', 'title': 'Error', 'text': error.response.data.errors })
            })
        }else{
            dispatch('ShowToast', { 'icon':'error', 'title':'Debe seleccionar una forma de envio'})
        }  
    },

     /**
	 *
	 * @param state
	 * @param dispatch
	 * @param event
	 */
    PaymentMethod({state,dispatch},e){
        dispatch('ShowLoadingToast', {'text': 'Agregando forma de pago' })
        let postData = {
            paymentMethod: e.target.payment.value,
            amount: e.target.quantity.value
        }
        Axios.post( `${AMBROSIA_URL}/order/${state.order.id}/add-payment-method`,postData )
        .then( r => {
            dispatch('ShowToast', { 'icon':'success', 'title':'Se agrego el metodo de pago'})
            dispatch('SetOrder', r.data.data );
        })
        .catch( e => {
            dispatch('ShowToast', { 'icon':'error', 'title': 'Error', 'text': e.response.data.errors })

        } )
        //commit('StateAssign', {paymentMethod:paymentMethod})
    },

    /**
	 * @param state
	 * @param dispatch
	 * @param paymentId
	 */
    RemovePaymentMethod({state,dispatch},id){
        dispatch('ShowLoadingToast', {'text': 'Quitando modo de pago' })
        let postData = { 
            transactionMatrixId: id, 
            amount: -1 
        }
        Axios.post( `${AMBROSIA_URL}/order/${state.order.id}/add-payment-method`, postData )
        .then( r => {
            dispatch('ShowToast', { 'icon':'success', 'title':'Se quito la forma de pago'})
            dispatch('SetOrder', r.data.data );
        } )
        .catch( e =>{
            dispatch('ShowToast', { 'icon':'error', 'title': 'Error', 'text': e.response.data.errors })
        })
    },

    /**
     * Sets the shipping address for the current order via a given
     * Address ID
     *
     * @param commit
     * @param state
     * @param dispatch
     * @param id
     * @constructor
     */
    AddShippingAddress({commit, state, dispatch}, id) {
        // -- Prevent the user from clicking anything else
        dispatch('ShowLoadingToast', {'text': 'Agregando direccion'})

        let postData = {
            addressId: id
        }

        // -- Make sure all promises are completed, otherwise have the user try again
        Axios.all([
            Axios.post(`${AMBROSIA_URL}/order/${state.order.id}/add-shipping-address`, postData),
            Axios.get(`${AMBROSIA_URL}/address/${id}/get-shipping-profile`)
        ])
        .then(r => {
            dispatch('SetOrder', r[0].data.data)
            commit('StateAssign', { shippingProfile: r[1].data.data })
            commit('StateAssign',{ checkoutStep: 'OrderConfirmationStep' })
        })
        .then(r => {
            dispatch('CloseToast')
            dispatch('ShowToast', {'icon': 'success', 'title': 'Se agrego direccion'})
        })
        .catch(ex => {
            dispatch('CloseToast')
            dispatch('ShowToast', { 'icon':'error', 'title': 'Error', 'text': ex.response.data.errors })
        })
    },
    /**
     * Gets the shipping profile for a given address
     * This should be updated whenever the order is fetched and every time the order
     * has a shipping address attached to it
     *
     * @param state
     * @param dispatch
     * @param address
     * @constructor
     */
    GetShippingProfileForAddress({commit, dispatch}, address) {
        if( !address ) return;

        // -- Fetch shipping profile
        Axios.get(`${AMBROSIA_URL}/address/${address.id}/get-shipping-profile`)
        .then(r => {
            commit( 'StateAssign', { shippingProfile: r.data.data } )
        })
        .catch(error => {
            dispatch('ShowToast', { 'icon':'error', 'title': 'Error', 'text': error.response.data.errors })
        })
    },

    /**
	 * @param state
	 * @param dispatch
	 * @param paymentId
	 */
    RemoveCoupon({state,dispatch}){
        dispatch('ShowLoadingToast', {'text': 'Removiendo cupon de compra' })
        let postData = {
            couponId:null
        }
        Axios.post( `${AMBROSIA_URL}/order/${state.order.id}/add-coupon`,postData)
        .then( r => {
            dispatch('SetOrder', r.data.data ) 
            dispatch('ShowToast', { 'icon':'success', 'title':'Se quito el cupon de compra'})
        })
        .catch( error => dispatch('ShowToast', { 'icon':'error', 'title': 'Error', 'text': error.response.data.errors }))
    },


     /**
	 *
	 * @param state
	 * @param dispatch
	 * @param event
	 */
    AddCoupon({state, dispatch},e){
        dispatch('ShowLoadingToast', {'text': 'Agregando cupon de compra' })
        let postData = {
            couponId:e.target.coupon.value
        }
        Axios.post( `${AMBROSIA_URL}/order/${state.order.id}/add-coupon`, postData)
        .then( r => {
            dispatch('SetOrder', r.data.data )
            dispatch('ShowToast', { 'icon':'success', 'title':'Se agrego el cupon a su compra'})
        } )
        .catch( error => {
            dispatch('ShowToast', { 'icon':'error', 'title': 'Error', 'text': error.response.data.errors })
        } )
    },

     /**
	 *
	 * @param commit
	 * @param dispatch
	 * @param event
	 */
    ConfirmPayment({commit, dispatch,state}){
        if( state.orderTotals.pendingToExpress > 0 ) return;
        commit('StateAssign', { checkoutStep: 'OrderVerificationStep' })
    },

    /**
     *
     * @param commit
     * @param e
     * @constructor
     */
    RetrieveSaturationTimes({ commit , dispatch } , e ){
        let postData = {
           date:e.target.value 
        }
        Axios.post( `${AMBROSIA_URL}/retrieve-next-saturation-times`, postData )
        .then( r => {
            commit('StateAssign', { ranges: r.data.data } );
        } )
        .catch( error => dispatch('ShowToast', { 'icon':'error', 'title': 'Error', 'text': error.response.data.errors }) )
    },
    /**
	 *
	 * @param state
	 * @param event
	 */
    PublishOrder({state,commit,dispatch}){
        dispatch('ShowLoadingToast', {'text': 'Creando orden' })
        Axios.post( `${AMBROSIA_URL}/order/${state.order.id}/publish`)
        .then(r => {
            commit('StateAssign', {orderSummary: r.data.data})
            dispatch('ShowToast', { 'icon':'success', 'title':'Orden creada'})
            dispatch('RouterPush','/completada')
        })
        .catch(error => {
            dispatch('ShowToast', { 'icon':'error', 'title': 'Error', 'text': error.response.data.errors })
        })
    }
}